import AdminHomeGroupModal from './AdminHomeGroupModal';

export default AdminHomeGroupModal;
